export default __webpack_public_path__ + "static/media/Flag_of_Macau.b54735e4.svg";